export default __webpack_public_path__ + "static/media/mr-tung.8b0cdaba.jpg";